import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';

const NotFound = () => {
    const { t } = useTranslation();

    return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
            <SEO
                title={t('not_found_page_title')}
                description={t('not_found_message')}
            />
            <h2>{t('not_found_message')}</h2>
        </div>
    );
};

export default NotFound;